module.exports = __webpack_public_path__ + "static/img/vaughan2.4895754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/vaughan2.jpg
// module id = 5
// module chunks = 9